import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";
import React from "react";
import { createRoot } from "react-dom/client";
import pageTemplate from "text!../../../templates/mylibrary/recordingsPageTemplate.html";
import RecordingsLibraryPage from "../../components/library/RecordingsLibraryPage";
import ti18n from "i18n!nls/MyLibraryi18n";

const RecordingsPageView = Backbone.View.extend({
  template: _.template(pageTemplate),

  pageName: "Recordings",

  events: {
    "click #homeHeaderButton": "onHomeButtonSelected",
    "click #pageActionButton": "onRecordSelected",
  },

  initialize: function () {
    this._reactRoot = null;
  },

  onHomeButtonSelected: function () {
    this.trigger("showHomePopup");
  },

  onRecordSelected: function () {
    this.trigger("showRecorder");
  },

  _onPageShow: function () {
    this.trigger("pageshow");
  },

  _onPageHide: function () {
    this.trigger("pagehide");
  },

  _onPageRemoved: function () {
    if (this._reactRoot) {
      this._reactRoot.unmount();
      this._reactRoot = null;
    }
    this.undelegateEvents();
    this.$el.removeData().unbind();
    this.stopListening();
  },

  _renderLibraryPage: function () {
    const reactContainer = this.$el.find("#libraryReactRoot").get(0);
    if (!reactContainer) return;

    if (!this._reactRoot) {
      this._reactRoot = createRoot(reactContainer);
    }

    this._reactRoot.render(React.createElement(RecordingsLibraryPage));
  },

  render: function () {
    this.$el.html(this.template({ ti18n: ti18n }));
    this.setElement(this.$el.find("div").first());
    this.$el.page();

    this._renderLibraryPage();

    this.$el
      .children(
        ".ui-header:not(.ui-header-fixed), .ui-content:not(.ui-popup), .ui-footer:not(.ui-footer-fixed)"
      )
      .wrapAll("<div class='ui-panel-wrapper'></div>");

    this.$el.on("pageshow", this._onPageShow.bind(this));
    this.$el.on("pagehide", this._onPageHide.bind(this));
    this.$el.on("remove", this._onPageRemoved.bind(this));

    return this;
  },
});

export default RecordingsPageView;
